import skipOnboardingLoader from "@loaders/skipOnboardingLoader"
import { Outlet } from "react-router-dom"
import EmailPage from "./EmailPage"
import LandingPage from "./LandingPage"
import PasswordPage from "./PasswordPage"
import QuizStepPage from "./QuizStepPage"

const onboardingRoutes = [
  {
    path: "/onboarding",
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <LandingPage />,
        index: true,
      },
      {
        element: <EmailPage />,
        path: "email",
      },
      {
        element: <PasswordPage />,
        path: "password",
      },
      {
        element: <QuizStepPage />,
        path: ":stepId",
      },
    ],
  },
]

export default onboardingRoutes
